import React, { useState } from 'react';
import whiteStarIcon from '@/assets/app/images/icon/white-star.png';

interface SelectEraListSheetProps {
  eraCategoryList: EraCategory[];
  selectedEraCategory: EraCategory;
  setSelectedEraCategory: (eraCategory: EraCategory) => void;
  closeSheet: () => void;
}

export const SelectEraListSheet: React.FC<SelectEraListSheetProps> = ({
  eraCategoryList,
  selectedEraCategory,
  setSelectedEraCategory,
  closeSheet,
}) => {
  const [currentEraCategory, setCurrentEraCategory] = useState<EraCategory>(selectedEraCategory);
  const handleClickEra = (eraCategory: EraCategory) => {
    setCurrentEraCategory(eraCategory);
    setSelectedEraCategory(eraCategory);
    closeSheet();
  };

  return (
    <div className="flex flex-col gap-2 w-full my-auto">
      {eraCategoryList.map(eraCategory => {
        const isSelected = currentEraCategory.eraCategoryId === eraCategory.eraCategoryId;

        return (
          <button
            key={eraCategory.eraCategoryId}
            onClick={() => handleClickEra(eraCategory)}
            style={{
              opacity: `${isSelected ? '1' : '0.5'}`,
              borderRadius: '25px',
            }}
            className={`w-full cursor-pointer transition-all duration-200 active:scale-[0.98] f-one-pop theme-${eraCategory.themeColor}`}
          >
            {/* [수정] justify-between 대신 내부 요소들이 자연스럽게 왼쪽부터 차도록 기본 flex로 변경 */}
            <div
              className="flex items-center theme-color-btn text-[#ffffff] py-3 pr-2 pl-5"
              style={{ borderBottomWidth: '4px' }}
            >
              {/* 1. 왼쪽 글자 영역: w-[110px] 정도로 늘리고 텍스트 정렬을 원하시는 대로 세팅합니다. */}
              {/* shrink-0 flex-none을 주어 다른 요소 때문에 공간이 절대 줄어들지 않게 합니다. */}
              <div className="text-base font-semibold w-[80px] text-center flex-none">
                {eraCategory.categoryName}
              </div>

              {/* 2. 가운데 세로선: flex-none을 주어 선 모양을 유지합니다. */}
              <div className="h-6 border-l border-white/40 mx-4 flex-none"></div>

              {/* 3. 오른쪽 기간 영역: flex-1을 주어 남은 우측 공간을 통째로 차지하게 만듭니다. */}
              {/* Figma 시안 비율 기준 12px(기존 14px), 기간이 "660 / 년"처럼 줄바꿈되지 않게 한 줄 고정 */}
              <div className="text-[12px] whitespace-nowrap text-left flex-1 pl-2">
                {eraCategory.period}
              </div>

              {/* 4. 선택 마크 (별 아이콘) */}
              {isSelected && (
                <div className="flex-none ml-auto mr-2">
                  <img src={whiteStarIcon} alt="selected" className="w-[20px] m-le" />
                </div>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};
